// Display-only labels for the venue's six zones. ZONE-A..F are the stable
// IDs Android/API use everywhere (never rename those) — this is purely how
// the Portal describes them to a human looking at the command center.
export const ZONE_LABELS: Record<string, string> = {
  A: "Registro / acceso / terraza",
  B: "Networking central",
  C: "Salón 02 / stands superiores",
  D: "Stands norte / centro",
  E: "Salón 01 / stand CICLOPE #4",
  F: "Salón 03 / acceso inferior",
};

export function zoneLabel(zoneLetter: string | null | undefined): string {
  if (!zoneLetter) return "—";
  return ZONE_LABELS[zoneLetter] ?? zoneLetter;
}
